import { useStorePlatform } from "@bcc/hooks/use-store-platform";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/** Values interpolated into every tour title/body, e.g. `{{platform}}` → "Shopify" */
export type TourTextParams = Readonly<Record<string, string>>;

/**
 * Resolves the values tour copy interpolates, so steps can say "your Shopify
 * products" or "your WooCommerce products" based on the vendor's connected
 * store. Falls back to a neutral label when no store is connected yet.
 */
export function useTourTextParams(): TourTextParams {
  const { t } = useTranslation();
  const { label: storeLabel } = useStorePlatform();
  const platform = storeLabel ?? (t("tour.textParams.platformFallback") as string);
  return useMemo(() => ({ platform }), [platform]);
}
